export default __webpack_public_path__ + "static/media/ic-drop-down-top.6ab7499c.svg";